import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PortalFilesPage } from "@/features/portalfiles/PortalFilesPage";

const search = z.object({
  folder: z.string().optional(),
});

export const Route = createFileRoute("/portal/files")({
  validateSearch: search,
  component: () => <PortalFilesPage search={Route.useSearch()} />,
});
